var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('autocomplete-preset',_vm._b({attrs:{"api":_vm.api,"enrich":_vm.enrichFn,"fields":_vm.fields,"resp-mapper":_vm.respMapper,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'autocomplete-preset',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }